// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__Th1Vp","menu_item":"menu_menu_item__bE85y","menu_link":"menu_menu_link__rj+4k"};